import { makeStyles, Theme, createStyles } from "@material-ui/core";

export default makeStyles((theme: Theme) => {
  return createStyles({
    dialogPaper: {
      overflowY: "hidden",
    },
    dialogContentRoot: {
      overflowY: "auto",
    },
  });
});
